var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65 20V19.85H7.5H2.5C1.87674 19.85 1.27901 19.6024 0.838299 19.1617C0.397588 18.721 0.15 18.1233 0.15 17.5V2.5C0.15 1.87674 0.397588 1.27901 0.838299 0.838299C1.27901 0.397588 1.87674 0.15 2.5 0.15H22.5C23.1233 0.15 23.721 0.397588 24.1617 0.838299C24.6024 1.27901 24.85 1.87674 24.85 2.5V17.5C24.85 18.1233 24.6024 18.721 24.1617 19.1617C23.721 19.6024 23.1233 19.85 22.5 19.85H14.875H14.8127L14.7688 19.8941L10.1453 24.5301C9.92186 24.7417 9.64641 24.85 9.375 24.85H8.75C8.45826 24.85 8.17847 24.7341 7.97218 24.5278C7.76589 24.3215 7.65 24.0417 7.65 23.75V20ZM13.9121 17.65H22.5H22.65V17.5V2.5V2.35H22.5H2.5H2.35V2.5V17.5V17.65H2.5H9.85V21.35V21.7121L10.1061 21.4561L13.9121 17.65ZM11.1442 10.9438L11.2501 11.0492L11.3559 10.9437L16.3624 5.9495L17.9129 7.5L11.25 14.1629L7.08713 10L8.63775 8.44938L11.1442 10.9438Z",
    fill: "#00BA52",
    stroke: "white",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.4f8fd589.svg";
export { ForwardRef as ReactComponent };